module.exports = __webpack_public_path__ + "img/illustrator-drawing.5cf052b7.svg";